import React from 'react';
import { LayoutBox, LayoutItem } from '../../../index';

/**
 * Base wrapper component for all field types
 * @param props - Component props
 * @param props.children - Child components to render within the field wrapper
 * @returns JSX element wrapping the field content
 */
export const BaseField = ({ children }: { children: React.ReactNode }) => (
  <LayoutBox>
    <LayoutItem>
      {children}
    </LayoutItem>
  </LayoutBox>
);
